import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class InactiveCampaignApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/campaignBundle/inactiveCampaign',
      requesterInfo,
    })
  }

  public async inactiveCampaign(request: number[]): Promise<boolean> {
    return await this.postAsync<boolean>(request)
  }
}
